module.exports = __webpack_public_path__ + "static/media/ziersch.3f9c9c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/supplier/Logos_Lieferanten/ziersch.png
// module id = 451
// module chunks = 0